angular.module('eStories.sortFilter', [
    /*eStories sort filters*/
    'eStories.sortFilter.model'

])
    .component('userContentFilterTopBar', {
        transclude: true,
        controller: 'SortCtrl',
        controllerAs: 'sortCtrl',
        templateUrl: '/components/templates/sortFilter/user_content/user-content-filter-top-bar.tmpl.html'
    })

    .component('browseFilterTopBar', {
        transclude: true,
        controller: 'SortCtrl',
        controllerAs: 'sortCtrl',
        templateUrl: '/components/templates/sortFilter/browse/browse-top-filter-bar.tmpl.html'
    })

    .component('seeAllFilterTopBar', {
        transclude: true,
        controller: 'SortCtrl',
        controllerAs: 'sortCtrl',
        templateUrl: '/components/templates/sortFilter/seeAll/see-all-filter-top-bar.tmpl.html'
    })

    .component('authorFilterTopBar', {
        transclude: true,
        controller: 'SortCtrl',
        controllerAs: 'sortCtrl',
        templateUrl: '/components/templates/sortFilter/publisher_author_narrator/author-filter-top-bar.tmpl.html'
    })

    .component('purchaseFilter', {
        transclude: true,
        controller: 'FilterCtrl',
        controllerAs: 'filterCtrl',
        templateUrl: '/components/templates/sortFilter/purchaseFilter.tmpl.html'
    })

    .component('sortFilterSideBar', {
        transclude: true,
        controller: 'FilterCtrl',
        controllerAs: 'filterCtrl',
        templateUrl: '/components/templates/sortFilter/sortFilterSideBar.tmpl.html'
    })

    .component('collapsedFilterSideBar', {
        transclude: true,
        controller: 'FilterCtrl',
        controllerAs: 'filterCtrl',
        templateUrl: '/components/templates/sortFilter/collapsedSortFilterSideBar.tmpl.html'
    })

    /*GENRE BROWSE PAGE*/
    .component('genreBrowseFilterTopBar', {
        transclude: true,
        controller: 'SortCtrl',
        controllerAs: 'sortCtrl',
        templateUrl: '/components/templates/sortFilter/genre_browse/genre-browse-filter-top-bar.tmpl.html'
    })

    .component('genreBrowseFilterSection', {
        transclude: true,
        controller: 'FilterCtrl',
        controllerAs: 'filterCtrl',
        templateUrl: '/components/templates/sortFilter/genre_browse/browseGenreFilterSection.tmpl.html'
    })

    .controller('SortCtrl', [
        'SortFilterFactory',
        'PagingModel',
        '$rootScope',
        '$state',
        '$stateParams',
        'CatalogModel',
        '$scope',
        '$window',
        '$location',
        'ModalsModel',
        'LL',
        function (SortFilterFactory,
                  PagingModel,
                  $rootScope,
                  $state,
                  $stateParams,
                  CatalogModel,
                  $scope,
                  $window,
                  $location,
                  ModalsModel,
                  LL) {

            var sortCtrl = this;

            sortCtrl.isGreatFirstListensSeeAll =
                CatalogModel.isPageName('great_first_listens') ||
                CatalogModel.isPageName('great_movie_tie_ins') ||
                CatalogModel.isPageName('pride_month') ||
                CatalogModel.isPageName('great_summer_listens') ||
                CatalogModel.isPageName('haunting_listens') ||
                CatalogModel.isPageName('holiday_season_2018') ||
                CatalogModel.isPageName('books_of_the_year_2018') ||
                CatalogModel.isPageName('chilling_listens') ||
                CatalogModel.isPageName('beyond_bracket_2019') ||
                CatalogModel.isPageName('national_book_award_longlist_2018') ||
                CatalogModel.isPageName('valentines_day') ||
                CatalogModel.isPageName('audie_winners') ||
                CatalogModel.isPageName('personalized_recommendations');

            sortCtrl.isThemedList = function () {
                return CatalogModel.isPageName('kid_control') ||
                    CatalogModel.isPageName('summer_listens') ||
                    CatalogModel.isPageName('off_the_beaten_path') ||
                    CatalogModel.isPageName('trippin') ||
                    CatalogModel.isPageName('me_time') ||
                    CatalogModel.isPageName('sizzlin_hot') ||
                    CatalogModel.isPageName('oprah_says_so') ||
                    CatalogModel.isPageName('short_and_sweet') ||
                    CatalogModel.isPageNameLike('back_to_school');
            };

            $scope.$on('setTotalCount', function (event, totalCount) {
                sortCtrl.totalCount = totalCount;
                sortCtrl.getActiveSortField(SortFilterFactory.filterObj.sortField);
            });

            sortCtrl.source = $location.path();
            // Only in mobile
            sortCtrl.redirectToMobileSortPage = function () {
                $location.path('/sort').search({source: sortCtrl.source});
            };

            sortCtrl.setWindowWidth = function () {
                sortCtrl.windowWidth = $window.innerWidth;
                safeApply($scope);
            };

            sortCtrl.setWindowWidth();

            $scope.$on("windowResized", function () {
                sortCtrl.setWindowWidth();
            });

            sortCtrl.currentState = $state.current.name;

            if (sortCtrl.currentState === 'eStories.mobileSort') {
                var firstString = $stateParams.source.split('/')[1];
                if (firstString === 'section') {
                    sortCtrl.sortOptionList = SortFilterFactory.getSortListOptions('eStories.navbars.seeAll');
                } else if (firstString === 'genres') {
                    sortCtrl.sortOptionList = SortFilterFactory.getSortListOptions('eStories.navbars.browseGenre');
                } else {
                    sortCtrl.sortOptionList = SortFilterFactory.getSortListOptions('eStories.navbars.' + firstString);
                }
            } else {
                sortCtrl.sortOptionList = SortFilterFactory.getSortListOptions(sortCtrl.currentState);
            }

            sortCtrl.shouldHideSortAndFilter = function () {
                return CatalogModel.isPageName('great_first_listens') ||
                    CatalogModel.isPageName('great_movie_tie_ins') ||
                    CatalogModel.isPageName('pride_month') ||
                    CatalogModel.isPageName('great_summer_listens') ||
                    CatalogModel.isPageName('personalized_recommendations') ||
                    CatalogModel.isPageName('kid_control') ||
                    CatalogModel.isPageName('summer_listens') ||
                    CatalogModel.isPageName('off_the_beaten_path') ||
                    CatalogModel.isPageName('trippin') ||
                    CatalogModel.isPageName('me_time') ||
                    CatalogModel.isPageName('sizzlin_hot') ||
                    CatalogModel.isPageName('oprah_says_so') ||
                    CatalogModel.isPageName('short_and_sweet') ||
                    CatalogModel.isPageNameLike('best_audiobooks_of') ||
                    CatalogModel.isPageNameLike('back_to_school');
            };

            if (sortCtrl.currentState !== 'eStories.mobileSort' &&
                sortCtrl.currentState !== 'eStories.mobileFilter') {
                sortCtrl.listViewMode = SortFilterFactory.listViewMode[sortCtrl.currentState].mode;
            }


            sortCtrl.changeViewMode = function (listView) {
                sortCtrl.showGridOptions = false;
                sortCtrl.listViewMode = listView;
                $rootScope.$broadcast('changeGridView', listView);
            };

            sortCtrl.getActiveSortField = function (value) {
                for (var i = 0; i < sortCtrl.sortOptionList.length; i++) {
                    var optionEnum = sortCtrl.sortOptionList[i].value !== null ?
                        sortCtrl.sortOptionList[i].value.toLowerCase() : null;
                    if (optionEnum === value) {
                        sortCtrl.activeSort = sortCtrl.sortOptionList[i].name;
                    }
                }
            };

            sortCtrl.getActiveSortField(SortFilterFactory.filterObj.sortField);

            sortCtrl.selectSortField = function (sortField) {
                SortFilterFactory.filterObj.sortField = sortField !== null ? sortField.toLowerCase() : null;
                SortFilterFactory.updateFilter = true;
                $rootScope.$broadcast('updateFilter', {
                    filterType: "sortField",
                    obj: SortFilterFactory.filterObj.sortField
                });
            };

            function constructGetParamsObj(pageNumber, filterObj) {
                //Save pagingData currentPage globally
                PagingModel.pagingData.currentPage = pageNumber;

                for (var param in SortFilterFactory.filterObj) {
                    if (SortFilterFactory.filterObj[param] == null) {
                        delete SortFilterFactory.filterObj[param];
                    }
                }
                SortFilterFactory.filterObj.pageNumber = pageNumber;
                if (filterObj && filterObj.obj !== null) {
                    if (filterObj.filterType === 'genreId') {
                        delete SortFilterFactory.filterObj.subGenreId;
                    }
                    SortFilterFactory.filterObj[filterObj.filterType] = filterObj.obj;
                }
                return SortFilterFactory.filterObj;
            }

            sortCtrl.selectSortFieldAndRedirectToResultPage = function (sortField) {
                SortFilterFactory.filterObj.sortField = sortField !== null ? sortField.toLowerCase() : null;
                PagingModel.pagingData.totalCount = null;
                PagingModel.viewedPagesMap = {};
                var filterObj = constructGetParamsObj(null,
                    {
                        filterType: "sortField",
                        obj: SortFilterFactory.filterObj.sortField
                    });
                $location.path($stateParams.source).search(filterObj);
            };

            sortCtrl.openUploadModal = function () {
                LL.tagEvent("Upload Select");
                ModalsModel.open('/uploader/uploadModal.tmpl.html', 'UploadCtrl', 'uploadCtrl')
            };

            $scope.$on('setName', function (event, name) {
                sortCtrl.entityName = name;
            });
        }])

    .controller('FilterCtrl', [
        'WS',
        'CatalogModel',
        '$rootScope',
        'SortFilterFactory',
        '$location',
        '$window',
        '$scope',
        '$stateParams',
        'PagingModel',
        '$state',
        'LL',
        function (WS,
                  CatalogModel,
                  $rootScope,
                  SortFilterFactory,
                  $location,
                  $window,
                  $scope,
                  $stateParams,
                  PagingModel,
                  $state,
                  LL) {


            var filterCtrl = this;

            filterCtrl.isGreatFirstListensSeeAll = !(CatalogModel.isPageName('great_first_listens') &&
                CatalogModel.isPageName('great_movie_tie_ins') &&
                CatalogModel.isPageName('pride_month') ||
                CatalogModel.isPageName('haunting_listens') &&
                CatalogModel.isPageName('holiday_season_2018') &&
                CatalogModel.isPageName('books_of_the_year_2018') &&
                CatalogModel.isPageName('chilling_listens') &&
                CatalogModel.isPageName('beyond_bracket_2019') &&
                CatalogModel.isPageName('national_book_award_longlist_2018') &&
                CatalogModel.isPageName('valentines_day') &&
                CatalogModel.isPageName('audie_winners') &&
                CatalogModel.isPageName('great_summer_listens') &&
                CatalogModel.isPageName('personalized_recommendations')
            );

            filterCtrl.isThemedList = function () {
                return CatalogModel.isPageName('kid_control') ||
                    CatalogModel.isPageName('summer_listens') ||
                    CatalogModel.isPageName('off_the_beaten_path') ||
                    CatalogModel.isPageName('trippin') ||
                    CatalogModel.isPageName('me_time') ||
                    CatalogModel.isPageName('sizzlin_hot') ||
                    CatalogModel.isPageName('oprah_says_so') ||
                    CatalogModel.isPageNameLike('back_to_school') ||
                    CatalogModel.isPageName('short_and_sweet');
            };

            if ($stateParams.source && $stateParams.type) {
                filterCtrl.filterType = $stateParams.type;
            }

            function constructGetParamsObj(pageNumber, filterObj) {
                //Save pagingData currentPage globally
                PagingModel.pagingData.currentPage = pageNumber;

                for (var param in SortFilterFactory.filterObj) {
                    if (SortFilterFactory.filterObj[param] == null) {
                        delete SortFilterFactory.filterObj[param];
                    }
                }
                SortFilterFactory.filterObj.pageNumber = pageNumber;
                if (filterObj && filterObj.obj != null) {
                    if (filterObj.filterType == 'genreId') {
                        delete SortFilterFactory.filterObj.subGenreId;
                    }
                    SortFilterFactory.filterObj[filterObj.filterType] = filterObj.obj;
                }
                return SortFilterFactory.filterObj
            };

            filterCtrl.setWindowWidth = function () {
                filterCtrl.windowWidth = $window.innerWidth;
                safeApply($scope);
            };

            filterCtrl.setWindowWidth();

            $scope.$on("windowResized", function () {
                filterCtrl.setWindowWidth();
            });

            filterCtrl.redirectToMobileFilterPage = function (type) {
                var source = $location.path();
                $location.path('/filter/' + type).search({source: source});
            };

            filterCtrl.durationList = SortFilterFactory.durationList;
            filterCtrl.formatList = SortFilterFactory.formatList;

            filterCtrl.priceTypeList = SortFilterFactory.priceTypeList;
            filterCtrl.onlyForFree = SortFilterFactory.onlyForFree;
            filterCtrl.onlyForCredit = SortFilterFactory.onlyForCredit;
            filterCtrl.onlyOnSale = SortFilterFactory.onlyOnSale;

            filterCtrl.activeGenre = SortFilterFactory.filterObj.genreId;
            filterCtrl.activeSubGenre = SortFilterFactory.filterObj.subGenreId;

            filterCtrl.activeParentGenre = null;
            filterCtrl.activeLanguage = SortFilterFactory.filterObj.languageId;
            filterCtrl.activeFormat = SortFilterFactory.filterObj.abridged != null ?
                JSON.parse(SortFilterFactory.filterObj.abridged) : null;

            filterCtrl.activeOnlyForFree = SortFilterFactory.filterObj.onlyForFree != null ?
                JSON.parse(SortFilterFactory.filterObj.onlyForFree) : null;
            filterCtrl.activeOnlyForCredit = SortFilterFactory.filterObj.onlyForCredit != null ?
                JSON.parse(SortFilterFactory.filterObj.onlyForCredit) : null;
            filterCtrl.activeOnlyOnSale = SortFilterFactory.filterObj.onlyOnSale != null ?
                JSON.parse(SortFilterFactory.filterObj.onlyOnSale) : null;

            filterCtrl.activeDurationString = SortFilterFactory.filterObj.duration;
            filterCtrl.exposeAllGenres = false;
            filterCtrl.showGenreSection = true;
            filterCtrl.showLanguageSection = true;
            filterCtrl.showDurationSection = true;
            filterCtrl.showFormatSection = true;
            filterCtrl.showPriceTypeSection = function () {
                return !CatalogModel.isPageNameLike('free_books');
            };

            filterCtrl.initTopLevelGenres = async (callbackFunc) => {
                const response = await CatalogModel.getFilterGenreList({});
                if (response.responseStatus !== 'SUCCESS') {
                    return;
                }
                SortFilterFactory.topLevelGenres = response.genreList;
                filterCtrl.topLevelGenres = response.genreList;
                filterCtrl.checkIfGenreNeedsToBeExposed(filterCtrl.activeGenre);
                if (callbackFunc != null) {
                    callbackFunc();
                }
            };

            filterCtrl.shouldExposeGenre = function (exposed) {
                return filterCtrl.exposeAllGenres ? true : exposed;
            };

            filterCtrl.checkIfGenreNeedsToBeExposed = function (genreId) {
                for (var i = 0; i < SortFilterFactory.topLevelGenres.length; i++) {
                    if (SortFilterFactory.topLevelGenres[i].id == genreId && !SortFilterFactory.topLevelGenres[i].exposed) {
                        filterCtrl.exposeAllGenres = true;
                    }
                }
            };

            filterCtrl.initAvailableLanguages = async () => {
                const response = await WS.callServer('/catalog/getFilterLanguageList', {});
                if (response.responseStatus == 'SUCCESS') {
                    SortFilterFactory.availableLanguages = response.languageList;
                    filterCtrl.availableLanguages = response.languageList;
                }
            };

            filterCtrl.getSubGenres = async function (genreId) {
                if (SortFilterFactory.cachedSubGenres[filterCtrl.activeGenre] != null) {
                    filterCtrl.subGenreList = SortFilterFactory.cachedSubGenres[filterCtrl.activeGenre];
                    filterCtrl.getSubGenreName();
                } else {
                    const response = await CatalogModel.getSubGenreList({genreId: genreId});
                    if (response.responseStatus !== 'SUCCESS' || response.genreList.length === 0) {
                        return;
                    }
                    filterCtrl.subGenreList = response.genreList;
                    //Save on cached object
                    SortFilterFactory.cachedSubGenres[filterCtrl.activeGenre] = filterCtrl.subGenreList;
                    filterCtrl.getSubGenreName();
                }
            };

            function updateGenreFilter(genreId) {
                SortFilterFactory.filterObj["subGenreId"] = null;
                SortFilterFactory.filterObj["genreId"] = genreId;
                broadcastFilterChange("genreId", genreId);
            }

            function updateMobileGenreFilter(genreId) {
                SortFilterFactory.filterObj["subGenreId"] = null;
                SortFilterFactory.filterObj["genreId"] = genreId;
                filterCtrl.mobileFilterObj = constructGetParamsObj(null, {filterType: 'genreId', obj: genreId});
                filterCtrl.activeGenre = genreId;
                filterCtrl.getSubGenres(genreId);
            }

            function updateSubGenreFilter(subGenreId) {
                SortFilterFactory.filterObj["subGenreId"] = subGenreId;
                broadcastFilterChange("subGenreId", subGenreId);
            }

            function updateMobileSubGenreFilter(subGenreId) {
                SortFilterFactory.filterObj["subGenreId"] = subGenreId;
                filterCtrl.mobileFilterObj = constructGetParamsObj(null, {filterType: 'subGenreId', obj: subGenreId});
                filterCtrl.activeSubGenre = subGenreId;
            }

            function updateDurationFilter(minHours, maxHours) {
                if (minHours || maxHours) {
                    minHours = minHours !== null ? minHours.toString() : 0;
                    maxHours = maxHours !== null ? maxHours.toString() : '';
                    var durationString = minHours + '-' + maxHours;
                    // if selected duration is the same as current duration then reset to null
                    if (SortFilterFactory.filterObj.duration === durationString) {
                        SortFilterFactory.filterObj.duration = null;
                    } else {
                        SortFilterFactory.filterObj.duration = durationString;
                        SortFilterFactory.filterObj.duration = SortFilterFactory.filterObj.duration.length > 0 ?
                            SortFilterFactory.filterObj.duration.replace(/(^,|,$)/g, "").replace(',,', ',') : null;
                    }
                } else {
                    SortFilterFactory.filterObj.duration = null;
                }
                broadcastFilterChange("duration", SortFilterFactory.filterObj.duration);
            }

            function updateMobileDurationFilter(minHours, maxHours) {
                minHours = minHours != null ? minHours.toString() : 0;
                maxHours = maxHours != null ? maxHours.toString() : '';
                SortFilterFactory.filterObj.duration = minHours + '-' + maxHours;
                ;
                SortFilterFactory.filterObj.duration = SortFilterFactory.filterObj.duration.length > 0 ?
                    SortFilterFactory.filterObj.duration.replace(/(^,|,$)/g, "").replace(',,', ',') : null;
                if (SortFilterFactory.filterObj.duration == '0-') {
                    SortFilterFactory.filterObj.duration = null;
                }
                filterCtrl.mobileFilterObj = constructGetParamsObj(null, {
                    filterType: 'duration',
                    obj: SortFilterFactory.filterObj.duration
                });
                filterCtrl.submitMobileFilter();
            }

            function updateLanguageFilter(languageId) {
                languageId = languageId != null ? languageId.toString() : '';
                if (SortFilterFactory.filterObj.languageId == null) {
                    SortFilterFactory.filterObj.languageId = languageId;
                } else {
                    if (SortFilterFactory.filterObj.languageId.indexOf(languageId) > -1) {
                        SortFilterFactory.filterObj.languageId = SortFilterFactory.filterObj.languageId.replace(languageId, '');
                    } else {
                        var result = SortFilterFactory.filterObj.languageId.concat(',' + languageId);
                        SortFilterFactory.filterObj.languageId = result;
                    }
                }
                SortFilterFactory.filterObj.languageId = SortFilterFactory.filterObj.languageId.length > 0 ?
                    SortFilterFactory.filterObj.languageId.replace(/(^,|,$)/g, "").replace(',,', ',') : null;
                broadcastFilterChange("languageId", SortFilterFactory.filterObj.languageId);
            }

            function updateFormatFilter(abridged) {
                if (JSON.stringify(abridged) == SortFilterFactory.filterObj.abridged) {
                    SortFilterFactory.filterObj.abridged = null;
                } else {
                    SortFilterFactory.filterObj.abridged = abridged;
                }
                broadcastFilterChange("abridged", SortFilterFactory.filterObj.abridged);
            }

            function updatePriceTypeFilter(priceType) {
                if (priceType.name === "onlyForCredit") {
                    JSON.stringify(priceType.value) === SortFilterFactory.filterObj.onlyForCredit ? SortFilterFactory.filterObj.onlyForCredit = null : SortFilterFactory.filterObj.onlyForCredit = priceType.value;
                    broadcastFilterChange("onlyForCredit", SortFilterFactory.filterObj.onlyForCredit);
                } else if (priceType.name === "onlyForFree") {
                    JSON.stringify(priceType.value) === SortFilterFactory.filterObj.onlyForFree ? SortFilterFactory.filterObj.onlyForFree = null : SortFilterFactory.filterObj.onlyForFree = priceType.value;
                    broadcastFilterChange("onlyForFree", SortFilterFactory.filterObj.onlyForFree);
                } else if (priceType.name === "onlyOnSale") {
                    JSON.stringify(priceType.value) === SortFilterFactory.filterObj.onlyOnSale ? SortFilterFactory.filterObj.onlyOnSale = null : SortFilterFactory.filterObj.onlyOnSale = priceType.value;
                    broadcastFilterChange("onlyOnSale", SortFilterFactory.filterObj.onlyOnSale);
                }
            }

            function broadcastFilterChange(filterType, obj) {
                SortFilterFactory.updateFilter = true;
                $rootScope.$broadcast('updateFilter', {filterType: filterType, obj: obj});
            }

            //Fires Every time filter is pressed
            filterCtrl.selectGenre = function (genreId, isMobile) {
                if (isMobile) {
                    updateMobileGenreFilter(genreId);
                } else {
                    updateGenreFilter(genreId);
                }
            };

            filterCtrl.selectSubGenre = function (subGenreId, isMobile) {
                if (isMobile) {
                    updateMobileSubGenreFilter(subGenreId);
                } else {
                    updateSubGenreFilter(subGenreId);
                }
            };

            filterCtrl.selectDuration = function (minHours, maxHours, isMobile) {
                if (isMobile) {
                    updateMobileDurationFilter(minHours, maxHours);
                } else {
                    updateDurationFilter(minHours, maxHours);
                }
            };

            filterCtrl.selectLanguage = function (languageId) {
                updateLanguageFilter(languageId)
            };

            filterCtrl.selectFormat = function (abridged) {
                updateFormatFilter(abridged);
            };

            filterCtrl.selectPriceType = function (priceTypeName) {
                updatePriceTypeFilter(priceTypeName);
            };

            filterCtrl.submitMobileFilter = function () {
                $location.path($stateParams.source).search(filterCtrl.mobileFilterObj);
            };

            // Get Duration Name for dropdown version of Filters
            filterCtrl.getDurationName = function () {
                if (filterCtrl.activeDurationString == null) {
                    filterCtrl.activeDurationName = 'All'
                } else {
                    for (var i = 0; i < filterCtrl.durationList.length; i++) {
                        if (filterCtrl.durationList[i].id == filterCtrl.activeDurationString) {
                            filterCtrl.activeDurationName = filterCtrl.durationList[i].name;
                        }
                    }
                }
            };

            // Get Genre name for dropdown version of filters
            filterCtrl.getGenreName = function () {
                if (filterCtrl.activeSubGenre == null) {
                    if (filterCtrl.activeGenre == null) {
                        filterCtrl.activeGenreName = 'All';
                    } else {
                        for (var i = 0; i < filterCtrl.topLevelGenres.length; i++) {
                            if (filterCtrl.topLevelGenres[i].id == parseInt(filterCtrl.activeGenre)) {
                                filterCtrl.activeGenreName = filterCtrl.topLevelGenres[i].name;

                            }
                        }
                    }
                }
            };

            // Get Sub Genre name for dropdown version of filters
            filterCtrl.getSubGenreName = function () {
                if (filterCtrl.activeSubGenre != null) {
                    for (var i = 0; i < filterCtrl.subGenreList.length; i++) {
                        if (filterCtrl.subGenreList[i].id == parseInt(filterCtrl.activeSubGenre)) {
                            filterCtrl.activeGenreName = filterCtrl.subGenreList[i].name;
                        }
                    }
                }
            };

            filterCtrl.getDurationName();

            // Active states of Duration Filter
            filterCtrl.getActiveDuration = function (durationString) {
                if (filterCtrl.activeDurationString) {
                    var durationArray = filterCtrl.activeDurationString.split(',');
                    for (var i = 0; i < durationArray.length; i++) {
                        if (durationArray[i] === durationString) {
                            return true;
                        }
                    }
                    return false;
                }
            };

            // Active States of Language Filter
            filterCtrl.getActiveLanguage = function (languageId) {
                if (filterCtrl.activeLanguage) {
                    var arrayOfActiveLangauges = filterCtrl.activeLanguage.split(',');
                    for (var i = 0; i < arrayOfActiveLangauges.length; i++) {
                        if (arrayOfActiveLangauges[i] == languageId.toString()) {
                            return true;
                        }
                    }
                    return false;
                }
            };

            filterCtrl.getActivePriceType = function (priceTypeName) {
                if (priceTypeName === "onlyForCredit") {
                    return filterCtrl.activeOnlyForCredit;
                } else if (priceTypeName === "onlyForFree") {
                    return filterCtrl.activeOnlyForFree;
                } else if (priceTypeName === "onlyOnSale") {
                    return filterCtrl.activeOnlyOnSale;

                }
            };

            //Check for Sub Genres (caching inside function)
            if (filterCtrl.activeGenre) {
                filterCtrl.getSubGenres(filterCtrl.activeGenre);
            }

            // Init Top Level Genres if not cached
            if (!SortFilterFactory.topLevelGenres) {
                filterCtrl.initTopLevelGenres(function () {
                    filterCtrl.getGenreName();
                });
            } else {
                filterCtrl.topLevelGenres = SortFilterFactory.topLevelGenres;
                filterCtrl.checkIfGenreNeedsToBeExposed(filterCtrl.activeGenre);
                filterCtrl.getGenreName();
            }

            // Init Available Languages if not cached
            if (!SortFilterFactory.availableLanguages) {
                filterCtrl.initAvailableLanguages();
            } else {
                filterCtrl.availableLanguages = SortFilterFactory.availableLanguages;
            }

            filterCtrl.tagBrowsedGenreLlEvent = function (genreName) {
                LL.tagBrowsedGenreLlEvent(genreName);
            };

            $scope.$on('setTotalCount', function (event, totalCount) {
                filterCtrl.totalCount = totalCount;
            });

            $scope.$on('newGenreId', function (e, genreId, subGenreId) {
                if (filterCtrl.topLevelGenres) {
                    filterCtrl.activeGenre = genreId;
                    filterCtrl.activeSubGenre = subGenreId;
                    filterCtrl.getSubGenres(genreId);
                    if (!subGenreId)
                        filterCtrl.getGenreName();
                }
            });
        }]);

